import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Layout from "./components/Layout";
import { WalletProvider } from "./context/WalletContext";
import { ToastProvider } from "./components/Toast";
import Home from "./pages/Home";
import Listed from "./pages/Listed";
import ListedTicket from "./pages/ListedTicket";
import Pairs from "./pages/Pairs";
import NewPage from "./pages/New";
import Book from "./pages/Book";
import Docs from "./pages/Docs";
import { isListedTicker } from "./data/mockData";

// Route `/nvda` → `/listed/nvda` (only if it's a real listed ticker)
function TickerAlias() {
  const { ticker } = useParams();
  const reserved = new Set(["listed", "pairs", "new", "book", "docs"]);
  if (reserved.has(ticker.toLowerCase())) return <Navigate to={`/${ticker.toLowerCase()}`} replace />;
  if (isListedTicker(ticker)) return <ListedTicket />;
  return <Navigate to="/listed" replace />;
}

function App() {
  return (
    <ToastProvider>
      <WalletProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/listed" element={<Listed />} />
              <Route path="/listed/:ticker" element={<ListedTicket />} />
              <Route path="/pairs" element={<Pairs />} />
              <Route path="/new" element={<NewPage />} />
              <Route path="/book" element={<Book />} />
              <Route path="/docs" element={<Docs />} />
              <Route path="/:ticker" element={<TickerAlias />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </WalletProvider>
    </ToastProvider>
  );
}

export default App;
